export const ProfileScreenRoute = "ProfileScreenRoute";
export const ShareScreenRoute = "ShareScreenRoute";
export const DeleteScreenRoute = "DeleteScreenRoute";
